import { fromFetch } from 'rxjs/fetch';

import { AuthHeaders } from '../../../models/auth-headers';
import { requiredHeaders } from '../../../models/required-headers';
import { ignoreData } from '../../../utils/ignore-data';
import { WeatherAlerts } from '../schemas/weather-alerts.schema';
import { tripManagementSettingsEnvironment } from '../trip-management-settings-environment';

/**
 * Updates the weather alerts configuration
 * @param weatherAlerts The new weather alerts configuration
 */
export function patchConfigurationWeatherAlerts(
  this: unknown,
  weatherAlerts: WeatherAlerts
) {
  return fromFetch(
    new Request(
      tripManagementSettingsEnvironment.resolve(
        this
      ).configurationWeatherAlerts,
      {
        method: 'PATCH',
        headers: {
          ...requiredHeaders,
          ...new AuthHeaders(),
        },
        body: JSON.stringify({ weatherAlerts }),
      }
    )
  ).pipe(ignoreData());
}
